module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAABT0lEQVQ4jY2SQStEYRSGX0OYJjEbkiyUBdNgY1ZKUUrZ8Q9kM8UvUP6A8hPsWFpQrKiZBcvZyEKkDGaWmA1NeSzm3JnP1736Tp3Oved7ezqd8wqQk71AESgB78APUAWOgUVP2073Zw64pxOvwC3w4fSOgEwSpAA0THgITDqibmAVqNj7DZD2IWng0QSbSSMD/cCZ6Q58SNGZIAkQ5SBQB76BYRdyaZCJAIiAPdNvRb2UpLykqqQnhcWV1ZmokZKUlfQZCJCkhtWsC6lJGrPvkBi3WnchJUlDkpYDIRtWy+0OsGKLqtgZ/1tqAWgCz0CPb7YTA50CAwmAeVouBtj2fRLd/9oEb8AusADkgTXzUJNO1IApHyKgD9gHvoiPF2DHzPYH1AX4ixuVtC5pVlLGrlCWdCGpKSmnlldG7G0pxKFxmXMmeoibJDSmJZ1LuvsFTxeEtiajd4AAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/search_icon.png
// module id = Xv+V
// module chunks = 1